import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './Revenue.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, ButtonGroup, TextField } from '@material-ui/core';
import RevenueTable from './components/RevenueTable';
import Toast from '../Layout/components/Toast';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import Axios from 'axios';
import { roleStr } from '../../common/common';

class Revenue extends PureComponent {
    constructor(props) {
        super(props);
        const initDate = this.initDate();
        this.state = {
            revenueData: [],
            fromDate: initDate.from,
            toDate: initDate.to,
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleDate = this.handleDate.bind(this);
    }
    render() {
        const {
            revenueData,
            fromDate,
            toDate,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="Revenue" subtitle="MANAGEMENT"></PageTitle>
                </div>
                <div className="tableTool h h-bt">
                    <div className="h">
                        <div>From</div>
                        <TextField
                            id="date"
                            type="date"
                            variant="outlined"
                            className="textDateField"
                            value={fromDate}
                            onChange={e => this.handleDateChange(e, 'fromDate')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: {
                                    height: 1,
                                },
                            }}
                        />
                        <div>To</div>
                        <TextField
                            id="date"
                            type="date"
                            variant="outlined"
                            className="textDateField"
                            value={toDate}
                            onChange={e => this.handleDateChange(e, 'toDate')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                style: {
                                    height: 1,
                                },
                            }}
                        />
                        <ButtonGroup size="small" aria-label="small outlined button group">
                            <Button onClick={e => this.handleDate(e, 1)}>Last month</Button>
                            <Button onClick={e => this.handleDate(e, 2)}>Current month</Button>
                            <Button onClick={e => this.handleDate(e, 3)}>Last year</Button>
                            <Button onClick={e => this.handleDate(e, 4)}>Current year</Button>
                        </ButtonGroup>

                    </div>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleDownload}>download</Button>
                    </div>
                </div>
                <RevenueTable
                    revenuesData={revenueData}
                />
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
        this.getRevenues();
    }
    getRevenues() {
        const { fromDate, toDate } = this.state;
        const params = {
            start_date: new Date(fromDate).getTime() / 1000,
            end_date: new Date(toDate).getTime() / 1000
        }
        this.getRevenue(params, (data) => {
            const revenueData = this.changeData(data);
            this.setState({
                revenueData
            })
        })
    }
    changeData(data) {
        console.log("data", data)
        if (data) {
            let revenueData = [];
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    let revenueObj = {};
                    const obj = data[key];
                    revenueObj.expanded = false;
                    revenueObj.name = key;
                    revenueObj.invoices = obj.invoices;
                    revenueObj.total = obj.total;
                    revenueData.push(revenueObj);
                }
            }
            return revenueData;
        }
        return [];
    }
    initDate() {
        const date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth(),
            from = new Date(y, m, 1),
            to = new Date(y, m + 1, 0);

        return {
            from: this.formatDay(from),
            to: this.formatDay(to)
        }
    }
    handleDate(e, type) {
        let fromDate = "";
        let toDate = "";
        if (type === 1) {//Last month
            fromDate = this.lastMonthDay(true);
            toDate = this.lastMonthDay(false);
        } else if (type === 2) {//Current month
            fromDate = this.crtMonthDay(true);
            toDate = this.crtMonthDay(false);
        } else if (type === 3) {//Last year
            fromDate = this.lastYearly(true);
            toDate = this.lastYearly(false);
        } else if (type === 4) {//Current year
            fromDate = this.crtYearly(true);
            toDate = this.crtYearly(false);
        } else {
            return;
        }
        this.setState({
            fromDate,
            toDate
        }, () => {
            this.getRevenues();
        })
    }
    handleDateChange(e, name) {
        const value = e.target.value;
        const { fromDate, toDate } = this.state;
        let fromDateStamp = new Date(fromDate).getTime();
        let toDataStamp = new Date(toDate).getTime();
        let valueDateStamp = new Date(value).getTime();
        if (name === "fromDate") {
            if (valueDateStamp > toDataStamp) {
                this.setState({
                    [name]: value,
                    toDate: value
                }, () => {
                    this.getRevenues();
                })
            } else {
                this.setState({
                    [name]: value,
                }, () => {
                    this.getRevenues();
                })
            }
        } else if (name === "toDate") {
            if (valueDateStamp < fromDateStamp) {
                this.showToast("The selected time cannot be earlier than the from time", "warning");
            } else {
                this.setState({
                    [name]: value,
                }, () => {
                    this.getRevenues();
                })
            }
        }
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleDownload() {
        const { fromDate, toDate } = this.state;
        const params = {
            start_date: new Date(fromDate).getTime() / 1000,
            end_date: new Date(toDate).getTime() / 1000
        }
        this.revenueDownload(params)
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    crtMonthDay(isFirst = true) {
        let date = new Date(), y = date.getFullYear(), m = date.getMonth();
        const firstDay = new Date(y, m, 1);
        const lastDay = new Date(y, m + 1, 0);
        return isFirst ? this.formatDay(firstDay) : this.formatDay(lastDay);
    }
    lastMonthDay(isFirst = true) {
        let date = new Date(), y = date.getFullYear(), m = date.getMonth() - 1;
        const firstDay = new Date(y, m, 1);
        const lastDay = new Date(y, m + 1, 0);
        return isFirst ? this.formatDay(firstDay) : this.formatDay(lastDay);
    }
    crtYearly(isFirst = true) {
        let date = new Date(), y = date.getFullYear();
        const firstDay = new Date(y, 0, 1);
        const lastDay = new Date(y, 11, 31);
        return isFirst ? this.formatDay(firstDay) : this.formatDay(lastDay);
    }
    lastYearly(isFirst = true) {
        let date = new Date(), y = date.getFullYear() - 1;
        const firstDay = new Date(y, 0, 1);
        const lastDay = new Date(y, 11, 31);
        return isFirst ? this.formatDay(firstDay) : this.formatDay(lastDay);
    }
    formatDay(date) {
        var d = date;
        var day = ("0" + d.getDate()).slice(-2);
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        return d.getFullYear() + "-" + (month) + "-" + (day);
    }
    getRevenue(params, callback = null) {
        instance.get(BASE_URL + roleStr() + '/billing/invoice/revenue', { params }).then((res) => {
            const data = res.data.data;
            if (callback) callback(data);
        }).catch((err) => {
            console.log(err)
        })
    }
    revenueDownload(params) {
        const { fromDate, toDate } = this.state;
        Axios({
            url: BASE_URL + roleStr() + '/billing/invoice/revenue/download',
            method: 'get',
            params,
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + window.localStorage.getItem('token')
            }
        }).then(function (res) {
            var blob = new Blob([res.data], { type: res.headers['content-type'] });
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fromDate + '_' + toDate + '.xls'; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
        }).catch(function () {
        })
    }
}

export default withRouter(Revenue);